// The role vocabulary, mirroring VALID_ROLES in backend/models/user.py. The
// backend is the enforcement point — these helpers only decide what the UI
// offers, so a page that hides a control still gets a 403 if it is bypassed.

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
  COUNTER: 'inventory_counter',
};

export const ROLE_OPTIONS = [
  { value: ROLES.USER, label: 'User' },
  { value: ROLES.MANAGER, label: 'Manager' },
  { value: ROLES.ADMIN, label: 'Admin' },
  { value: ROLES.COUNTER, label: 'Inventory Counter' },
];

export const roleLabel = (role) =>
  ROLE_OPTIONS.find((option) => option.value === role)?.label || role || '-';

export const isAdmin = (user) => user?.role === ROLES.ADMIN;

export const isInventoryCounter = (user) => user?.role === ROLES.COUNTER;

// The only pages an inventory_counter account may open. Mirrors the backend's
// INVENTORY_COUNTER_ALLOWED in backend/utils/decorators.py.
export const COUNTER_PATHS = ['/inventory/count', '/time-clock'];

// Where a counter account lands after login (or on any path outside COUNTER_PATHS).
export const COUNTER_HOME = '/time-clock';

// Admin or manager: may edit the foal waitlist, and rename or remove reference
// data. Every logged-in user can still read those lists and create new
// reference values inline from the horse, expense and feed forms.
export const canManage = (user) => isAdmin(user) || user?.role === ROLES.MANAGER;
